import { ODataSelect } from "@iconics/core";

export class Delegate extends ODataSelect
{
    public Delegate_Id = '';
    public DelegateUser_Id = '';
    public DelegateUserName = '';
    public DelegateEmail = '';
    public DelegateDisplayName: string | null = '';
    public PrimaryDisplayName? = '';
    public PrimaryUserName? = '';
    public PrimaryEmail? = '';
    public PrimaryUser_Id? = '';
}

export class User extends ODataSelect
{
    public Id = '';
    public DisplayName?: string;
    public IdentityProviderId = 0;
    public UserType = '';
    public UserName = '';
    public FirstName?: string;
    public LastName?: string;
    public PreferredName?: string;
    public CompanyName?: string;
    public Email = '';

    public toSelect(): string
    {
        return ''; // $select doesn't support DisplayName
    }
}